import { combinePath } from "brew-js/util/path";
import { EKMS_URL } from "src/config/env";
import dom from "zeta-dom/dom";
import { ZetaEventContainer } from "zeta-dom/events";

interface ServiceWorkerEventMap {
    getAuthorizationHeader: Zeta.ZetaAsyncHandleableEvent<{ authorization: string } | null | undefined>;
}

const eventContainer = new ZetaEventContainer<Element, ServiceWorkerEventMap>();

export let serviceWorkerEnabled = false;

export function onServiceWorkerEvent<E extends keyof ServiceWorkerEventMap>(event: E, handler: Zeta.ZetaEventHandler<E, ServiceWorkerEventMap>) {
    return eventContainer.add(dom.root, event, handler);
}

export async function initServiceWorker() {
    const iframe = document.createElement('iframe');
    iframe.src = combinePath(EKMS_URL, 'frame.html');
    iframe.setAttribute('style', 'position:fixed;top:-10px;left:-10px;width:1px;height:1px;border:0');
    iframe.addEventListener('load', () => {
        const channel = new MessageChannel();
        channel.port1.addEventListener('message', async (event) => {
            const { action, data } = event.data;
            const port = event.ports[0];
            const promise = eventContainer.emit(action, dom.root, data);
            try {
                if (!promise) {
                    throw new Error('Unknown request');
                }
                port.postMessage(await promise);
            } catch (err) {
                port.postMessage({ error: err });
            }
        });
        channel.port1.start();
        iframe.contentWindow!.postMessage('', new URL(EKMS_URL).origin, [channel.port2]);
    });

    await dom.ready;
    document.body.appendChild(iframe);
}
